import { chargeServiceMatrixConstants } from '../../_constants';
import { chargeServiceMatrixService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const chargeServiceMatrixActions = {
    getAllChargeServiceMatrix,
    getChargeServiceMatrixById,
    updateChargeServiceMatrix,
    createChargeServiceMatrix,
    createChargeServiceMatrixSolo,
    deleteChargeServiceMatrix,
    searchChargeServiceMatrix,
    activation,
    getFullServiceServiceMatrix,
};

function fetched() { return { type: chargeServiceMatrixConstants.CHARGE_MATRIX_FETCHED } }
function fetching() { return { type: chargeServiceMatrixConstants.CHARGE_MATRIX_FETCHING } }

function activation(id, isActive) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        chargeServiceMatrixService.activation(id, isActive)
            .then(
                success => {
                    dispatch(fetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getChargeServiceMatrixById(id));
                    dispatch(alertActions.success(isActive ? 'Charge activated successfully' : 'Charge deactivated successfully'))
                },
                error => {
                    dispatch(confirmPromptActions.hide());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function searchChargeServiceMatrix(skip, take, search, filter) {
    return dispatch => {
        chargeServiceMatrixService.searchChargeServiceMatrix(skip, take, search, filter)
            .then(
                chargesServiceMatrix => {
                    if (chargesServiceMatrix.length > 0) {
                        dispatch(searchCharge(chargesServiceMatrix))
                    } else {
                        dispatch(alertActions.error(chargesServiceMatrix.message));
                    }
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function searchCharge(chargesServiceMatrix) { return { type: chargeServiceMatrixConstants.SEARCH_CHARGE_SERVICE_MATRIX, chargesServiceMatrix } }
}

function getAllChargeServiceMatrix(skip, take) {
    return dispatch => {
        dispatch(fetching());

        chargeServiceMatrixService.getAllChargeServiceMatrix(skip, take)
            .then(
                chargesServiceMatrix => {
                    if (chargesServiceMatrix.length > 0) {
                        dispatch(success(chargesServiceMatrix));
                        dispatch(fetched());
                    } else {
                        dispatch(fetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(chargesServiceMatrix) { return { type: chargeServiceMatrixConstants.GET_CHARGE_SERVICE_MATRIX, chargesServiceMatrix } }
}

function getChargeServiceMatrixById(code) {
    return dispatch => {
        dispatch(fetching());

        chargeServiceMatrixService.getChargeServiceMatrixById(code)
            .then(
                chargeServiceMatrix => {
                    dispatch(success(chargeServiceMatrix))
                    dispatch(fetched());
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );

    };
    function success(chargeServiceMatrix) { return { type: chargeServiceMatrixConstants.GET_CHARGE_SERVICE_MATRIX_BY_ID, chargeServiceMatrix } }
}

function updateChargeServiceMatrix(id, Charge, userProfile) {
    return dispatch => {
        dispatch(updatingCharge());
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        chargeServiceMatrixService.updateChargeServiceMatrix(Charge, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.success('Charge Service Matrix updated successfully'))
                    window.location.href = '/master_data/charges/read/' + id;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function updatingCharge() { return { type: chargeServiceMatrixConstants.UPDATE_CHARGE_SERVICE_MATRIX } }
}

function createChargeServiceMatrix(Charge) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        chargeServiceMatrixService.createChargeServiceMatrix(Charge)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.success('Charge Service Matrix added successfully'));
                    window.location.href = '/master_data/charges';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function createChargeServiceMatrixSolo(id, Charge) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        chargeServiceMatrixService.createChargeServiceMatrix(Charge)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.success('Charge Service Matrix added successfully'));
                    window.location.href = '/master_data/charges/read/' + id;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function deleteChargeServiceMatrix(id, type, chargeCode) {
    return dispatch => {
        dispatch(fetching());
        dispatch(userActions.notallowLeavePage());
        chargeServiceMatrixService.deleteChargeServiceMatrix(id, chargeCode)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(fetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Charge Service Matrix deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/charges';
                            break;
                        default:
                            dispatch(getFullServiceServiceMatrix());
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    // dispatch(getAllChargeServiceMatrix(0, take));
                    dispatch(fetched());
                }
            );
    };
}

function getFullServiceServiceMatrix() {
    return dispatch => {
        chargeServiceMatrixService.getFullServicesMatrix()
            .then(
                chargesServiceMatrix => dispatch(success(chargesServiceMatrix)),
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(chargesServiceMatrix) { return { type: chargeServiceMatrixConstants.GET_FULL_CHARGE_SERVICE_MATRIX, chargesServiceMatrix } }
}
